export default "__VITE_ASSET__37dfb113__"